import { UserRoleResourceTypeMappings } from '@aa/nest/auth';
import { createBaseResourceActions } from '../create-base-resource-actions';

// @aa:gen-ignore

const domainSlug = '[USER ROLE]';
export const userRoleActions =
  createBaseResourceActions<UserRoleResourceTypeMappings>(domainSlug);
